import React, { useState, useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import { Form, Field } from 'react-final-form';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import Table from '../../shared/table/Table';
import { selectorTypes } from '../../shared/table/TableRow';
import SvgXIcon from '../../svg/XIcon';
import Button, {
  buttonTypes,
  buttonSizes,
  buttonTextSizes,
  buttonFunctions,
} from '../../shared/Button';
import {
  searchText,
  submitText,
  cancelText,
  descriptionText,
  phoneText,
  notesText,
  
} from '../../shared/SharedInternationalizations';
import InlineHelpText from '../../shared/InlineHelpText';
import HelpIcon from '../../shared/HelpIcon';
import {
  getAllAlertDevices,
  loadAssignedAlertGroupList,
  loadProcessDetails,
} from '../../../redux/actions/alertDeviceActions';
import { required } from '../../../utilities/general';
import { Condition } from '../../shared/Condition';

export function UnconnectedAddEditAlertPhoneNumber(props) {
  const {
    deviceDetails,
    deviceType,
    alertDeviceCategories,
    onSubmit,
    interfaces,
    'data-test': dataTest,
  } = props;

  const categoriesArr = Object.values(alertDeviceCategories);

  const [categoryFilter, setCategoryFilter] = useState('');

  useEffect(() => {
    props.dispatch(getAllAlertDevices());
    props.dispatch(loadAssignedAlertGroupList());
    props.dispatch(loadProcessDetails());
  }, []); // eslint-disable-line

  /**
   * Function to set the search value for active filtering for users
   * @param {object} event - The event from typing in the value to the search bar
   * @fires setUsersFilter - Updates local state with the value typed into the search bar
   */
  const categorySearchFilter = (event) => {
    const value = event.target.value;
    setCategoryFilter(value);
  };
  const [showCategoryHelpText, setShowCategoryHelpText] = useState(false);
  const categoryHelpTextRef = useRef();
  function toggleCategoryHelpText(value) {
    setShowCategoryHelpText(value);
  }
  const categoryHelpText = (
    <FormattedMessage
      id="addEditAlertPhoneNumber.categoryHelpText"
      defaultMessage="The device category."
      description="Help text."
    />
  );
  const [showPhoneHelpText, setShowPhoneHelpText] = useState(false);
  const phoneHelpTextRef = useRef();
  function togglePhoneHelpText(value) {
    setShowPhoneHelpText(value);
  }
  const phoneHelpText = (
    <FormattedMessage
      id="addEditAlertPhoneNumber.phoneHelpText"
      defaultMessage="The phone number SARA will use to contact this user."
      description="Help text."
    />
  );
  const [showRetryCallingHelpText, setShowRetryCallingHelpText] = useState(
    false
  );
  const retryCallingHelpTextRef = useRef();
  function toggleRetryCallingHelpText(value) {
    setShowRetryCallingHelpText(value);
  }
  const retryCallingHelpText = (
    <FormattedMessage
      id="addEditAlertPhoneNumber.retryCallingHelpText"
      defaultMessage="SARA will retry calling this user if the call goes to voicemail."
      description="Help text."
    />
  );
  const [
    showRetryCallingNoAnswerHelpText,
    setShowRetryCallingNoAnswerHelpText,
  ] = useState(false);
  const retryCallingNoAnswerHelpTextRef = useRef();
  function toggleRetryCallingNoAnswerHelpText(value) {
    setShowRetryCallingNoAnswerHelpText(value);
  }
  const retryCallingNoAnswerHelpText = (
    <FormattedMessage
      id="addEditAlertPhoneNumber.retryCallingNoAnswerHelpText"
      defaultMessage="SARA will retry calling this user if the phone is not picked up."
      description="Help text."
    />
  );
  const [showTimesToCallHelpText, setShowTimesToCallHelpText] = useState(false);
  const timesToCallHelpTextRef = useRef();
  function toggleTimesToCallHelpText(value) {
    setShowTimesToCallHelpText(value);
  }
  const timesToCallHelpText = (
    <FormattedMessage
      id="addEditAlertPhoneNumber.timesToCallHelpText"
      defaultMessage="This is the number if times SARA will call this user to attempt to have them check in if there is no answer."
      description="Help text."
    />
  );
  const [
    showMinutesBetweenCallsHelpText,
    setShowMinutesBetweenCallsHelpText,
  ] = useState(false);
  const minutesBetweenCallsHelpTextRef = useRef();
  function toggleMinutesBetweenCallsHelpText(value) {
    setShowMinutesBetweenCallsHelpText(value);
  }
  const minutesBetweenCallsHelpText = (
    <FormattedMessage
      id="addEditAlertPhoneNumber.minutesBetweenCallsHelpText"
      defaultMessage="This is how long SARA will wait before re-calling this user."
      description="Help text."
    />
  );
  const [showRestrictCallsHelpText, setShowRestrictCallsHelpText] = useState(
    false
  );
  const restrictCallsHelpTextRef = useRef();
  function toggleRestrictCallsHelpText(value) {
    setShowRestrictCallsHelpText(value);
  }
  const restrictCallsHelpText = (
    <FormattedMessage
      id="addEditAlertPhoneNumber.restrictCallsHelpText"
      defaultMessage="Restricts this device to use only the line or process specified."
      description="Help text."
    />
  );
  const [
    showInterfaceToRestrictCallsHelpText,
    setShowInterfaceToRestrictCallsHelpText,
  ] = useState(false);
  const interfaceToRestrictCallsHelpTextRef = useRef();
  function toggleInterfaceToRestrictCallsHelpText(value) {
    setShowInterfaceToRestrictCallsHelpText(value);
  }
  const interfaceToRestrictCallsHelpText = (
    <FormattedMessage
      id="addEditAlertPhoneNumber.interfaceToRestrictCallsHelpText"
      defaultMessage="Restricts this device to use only the line or process specified."
      description="Help text."
    />
  );
  const [showDescriptionHelpText, setShowDescriptionHelpText] = useState(false);
  const descriptionHelpTextRef = useRef();
  function toggleDescriptionHelpText(value) {
    setShowDescriptionHelpText(value);
  }
  const descriptionHelpText = (
    <FormattedMessage
      id="addEditAlertPhoneNumber.descriptionHelpText"
      defaultMessage="The description for this phone device."
      description="Help text."
    />
  );

  const [showNotesHelpText, setShowNotesHelpText] = useState(false);
  const notesHelpTextRef = useRef();
  function toggleNotesHelpText(value) {
    setShowNotesHelpText(value);
  }
  const notesHelpText = (
    <FormattedMessage
      id="addEditAlertPhoneNumber.notesHelpText"
      defaultMessage="This is a place to record notes about the user."
      description="Help text."
    />
  );

  const [showNotifyOnClearHelpText, setShowNotifyOnClearHelpText] = useState(
    false
  );
  const notifyOnClearHelpTextRef = useRef();
  function toggleNotifyOnClearHelpText(value) {
    setShowNotifyOnClearHelpText(value);
  }
  const notifyOnClearHelpText = (
    <FormattedMessage
      id="addEditAlertPhoneNumber.notifyOnClearHelpText"
      defaultMessage="This will allow you to receive a call once the alarm is confirmed."
      description="Help text."
    />
  );

  function interfaceOptions() {
    const statusDisplay = Object.values(interfaces).map((int, index) => {// eslint-disable-line
      if (int.process_type === 5) {
        return (
          <option value={int.thread_name} key={index}>
            {int.thread_name}
          </option>
        );
      }
    });

    statusDisplay.unshift(
      <FormattedMessage
        id="addEditAlertPhone.selectModeText"
        defaultMessage="<b>- Please select an interface -</b>"
        key="blank"
        values={{
          b: (msg) => <option value="">{msg}</option>,
        }}
      />
    );

    return statusDisplay;
  }

  /**
   * Function to generate the users table
   * @returns {object} - The table of users
   */
  const alertDeviceCategoryTable = (values) => {
    // map over the users and put into the format that is required for the table component
    const initialFilterList = categoriesArr.filter((d) => {
      if (values.alert_device_category === d.alert_device_category) {
        return false;
      } else {
        return true;
      }
    });

    const categoryArray = initialFilterList.map((d) => {
      return {
        selector: {
          sortBy: d.alert_device_category,
          display: d.alert_device_category,
        },
        description: {
          sortBy: d.description.toUpperCase(),
          display: d.description,
        },
      };
    });

    let searchedCategories = [];
    // Take the array and filter based on the text entered in the search bar.
    if (categoryFilter !== '') {
      searchedCategories = categoryArray.filter((item) => {
        let filterResult = false;
        // Make the device name uppercase for case insensitivity
        const description = item.description.display.toUpperCase();

        // filter based off the includes() value with the entered text (also switched to uppercase) as the filter parameter
        if (description.includes(categoryFilter.toUpperCase())) {
          filterResult = true;
        }
        return filterResult;
      });
    } else {
      searchedCategories = categoryArray;
    }

    const tableHeadings = [
      {
        isSortable: false,
        display: '',
      },

      {
        isSortable: true,
        sortBy: 'description',
        display: descriptionText,
      },
    ];
    // generates the actual table
    const table = (
      <Table
        hasTableHead={true}
        hasSelector={true}
        tableHeadings={tableHeadings}
        selectorName="alert_device_category"
        selectorParamValue="alert_device_category"
        sortParam="description"
        tableData={searchedCategories}
        selectorType={selectorTypes.radio}
        tableStyles="table__constrained table-layout__1-column--selector"
        data-test="alert-device-category-table"
      />
    );

    return table;
  };

  /**
   * Function to generate the parent unit table
   * @returns {object} - The table of parent units
   */
  const selectedAlertDeviceCategoryTable = (values) => {
    let table;
    let categoryId = values.alert_device_category;

    let deviceRows;
    if (categoryId) {
      const filteredDevices = [];

      let thisId = categoryId;
      if (typeof categoryId === 'string') {
        thisId = parseInt(categoryId);
      }
      if (alertDeviceCategories[thisId]) {
        filteredDevices.push(alertDeviceCategories[thisId]);
      }

      deviceRows = filteredDevices.map((d) => {
        const removeButton = (
          <label>
            <Field
              className="visually-hidden"
              name="alert_device_category"
              component="input"
              type="radio"
              value={d.alert_device_category}
            />
            <SvgXIcon />
          </label>
        );

        return {
          button: {
            sortBy: '',
            display: removeButton,
          },

          description: {
            sortBy: d.description.toUpperCase(),
            display: d.description,
          },
        };
      });

      const tableHeadings = [
        {
          isSortable: false,
          display: '',
        },
        {
          isSortable: false,
          sortBy: 'description',
          display: descriptionText,
        },
      ];

      // generates the actual table
      table = (
        <Table
          hasTableHead={true}
          hasSelector={false}
          tableHeadings={tableHeadings}
          sortParam="description"
          tableData={deviceRows}
          tableStyles="table__constrained table-layout__1-column--selector"
          data-test="alert-device-selected-category-table"
        />
      );

      return table;
    } else {
      return '';
    }
  };

  let details = {};

  if (!deviceDetails) {
    details = {
      alert_group_id: [],
      alert_device_type: deviceType,
      user: deviceDetails.user || '',
    };
  } else {
    details = {
      alert_device_id: deviceDetails.alert_device_id,
      alert_description: deviceDetails.alert_description || '',
      phone_number: deviceDetails.phone_number || '',
      retry_after_noans: deviceDetails.retry_after_noans,
      retry_after_msg: deviceDetails.retry_after_msg,
      retry_cnt: deviceDetails.retry_cnt || 1,
      retry_interval: deviceDetails.retry_interval || 0,
      notify_on_clear: deviceDetails.notify_on_clear,
      restrict_to_interface: deviceDetails.interface_name ? true : false,
      interface_name: deviceDetails.interface_name || null,
      notes: deviceDetails.notes || '',
      alert_device_type: deviceDetails.alert_device_type,
      user: deviceDetails.user || '',
      subtype: deviceDetails.subtype || 0,
      resident_id: deviceDetails.resident_id || 0,
      alert_device_category: deviceDetails.alert_device_category || null,
    };
  }

  return (
    <React.Fragment>
      <Form
        onSubmit={onSubmit}
        keepDirtyOnReinitialize={true}
        initialValues={{
          ...details,
        }}
        render={({
          handleSubmit,
          pristine,
          invalid,
          reset,
          submitting,
          values,
        }) => (
          <form
            data-test={dataTest || "add-edit-alert-phone-number-form"}
            onSubmit={handleSubmit}
            className="associate-users-units__form-container">
            <Field
              className="visually-hidden"
              name="user"
              component="input"
              type="text"
            />
            <Field
              className="visually-hidden"
              name="alert_device_type"
              component="input"
              type="number"
            />
            <Field
              className="visually-hidden"
              name="last_contact"
              component="input"
              type="text"
            />
            <Field
              className="visually-hidden"
              name="next_alert"
              component="input"
              type="text"
            />
            <Field
              className="visually-hidden"
              name="subtype"
              component="input"
              type="number"
            />
            <Field
              className="visually-hidden"
              name="resident_id"
              component="input"
              type="number"
            />
            <div className="content-display__container">
              <div className="content-display__column content-display__column--1-2">
                <div className="content-display__item-container">
                  <div className="item-container__main-container">
                    <label
                      className="text-large text-light text-deep-blue form-item__field-message--required"
                      htmlFor="alert_description">
                      {descriptionText}:
                    </label>
                    <Field
                      className="form-item__field"
                      name="alert_description"
                      component="input"
                      type="text"
                      validate={required}>
                      {({ input, meta }) => (
                        <React.Fragment>
                          <input
                            {...input}
                            type="text"
                            className={
                              meta.error && meta.touched
                                ? 'form-item__field form-item__field--error'
                                : 'form-item__field'
                            }
                          />
                          {meta.error && meta.touched && (
                            <span className="form-item__field-message--required text-small">
                              {meta.error}
                            </span>
                          )}
                        </React.Fragment>
                      )}
                    </Field>
                  </div>
                  <div className="item-container__info-container">
                    <HelpIcon
                      onClick={() =>
                        descriptionHelpTextRef.current.toggleHelpText()
                      }
                      toggled={showDescriptionHelpText}
                      styles="margin-left-5"
                    />
                  </div>
                </div>
                <InlineHelpText
                  ref={descriptionHelpTextRef}
                  toggleFunction={toggleDescriptionHelpText}
                  message={descriptionHelpText}
                />
              </div>
              <div className="content-display__column content-display__column--1-2">
                <div className="content-display__item-container">
                  <div className="item-container__main-container">
                    <label
                      className="text-large text-light text-deep-blue form-item__field-message--required"
                      htmlFor="phone_number">
                      {phoneText}:
                      
                    </label>
                    <Field
                      className="form-item__field"
                      name="phone_number"
                      component="input"
                      type="tel"
                      pattern="[0-9:,;#\-()\s]+"
                      validate={(values) => {
                        // prettier-ignore
                        const regex =/^[0-9:\,;#\(\)\s-]+$/g; //eslint-disable-line

                        if (values) {
                          if (regex.test(values)) {
                            return undefined;
                          } else {
                            return 'Please enter a valid phone number. This can contain numbers and the following special characters: ( ) , : ;';
                          }
                        } else {
                          return 'This field is required.';
                        }
                      }}>
                      {({ input, meta }) => (
                        <React.Fragment>
                          <input
                            {...input}
                            type="tel"
                            pattern="[0-9:,;#\-()\s]+"
                            className={
                              meta.error
                                ? 'form-item__field--noInvalid form-item__field--noInvalid--error'
                                : 'form-item__field--noInvalid'
                            }
                          />
                          {meta.error && (
                            <span className="form-item__field-message--required text-small">
                              {meta.error}
                            </span>
                          )}
                        </React.Fragment>
                      )}
                    </Field>
                  </div>
                  <div className="item-container__info-container">
                    <HelpIcon
                      onClick={() => phoneHelpTextRef.current.toggleHelpText()}
                      toggled={showPhoneHelpText}
                      styles="margin-left-5"
                    />
                  </div>
                </div>
                <InlineHelpText
                  ref={phoneHelpTextRef}
                  toggleFunction={togglePhoneHelpText}
                  message={phoneHelpText}
                />
              </div>
              <div className="content-display__column content-display__column--1-2">
                <div className="content-display__item-container">
                  <div className="item-container__main-container">
                    <label className="text-large text-light text-deep-blue">
                      <Field
                        name="retry_after_noans"
                        component="input"
                        type="checkbox"
                        className="margin-right-10"
                      />
                      <FormattedMessage
                        id="addEditAlertPhoneNumber.retryCallingNoAnswerText"
                        defaultMessage="Retry calling if there is no answer"
                        description="Set the display mode for this user"
                      />
                    </label>
                  </div>
                  <div className="item-container__info-container">
                    <HelpIcon
                      styles="margin-left-5 keep-size"
                      onClick={() =>
                        retryCallingNoAnswerHelpTextRef.current.toggleHelpText()
                      }
                      toggled={showRetryCallingNoAnswerHelpText}
                    />
                  </div>
                </div>
                <InlineHelpText
                  ref={retryCallingNoAnswerHelpTextRef}
                  toggleFunction={toggleRetryCallingNoAnswerHelpText}
                  message={retryCallingNoAnswerHelpText}
                />
              </div>
              <div className="content-display__column content-display__column--1-2">
                <Condition when="retry_after_noans" is={true}>
                  <div className="content-display__item-container">
                    <div className="item-container__main-container">
                      <label className="text-large text-light text-deep-blue">
                        <Field
                          name="retry_after_msg"
                          component="input"
                          type="checkbox"
                          className="margin-right-10"
                        />
                        <FormattedMessage
                          id="addEditAlertPhoneNumber.retryCallingText"
                          defaultMessage="Retry calling after leaving a message"
                          description="Set the display mode for this user"
                        />
                      </label>
                    </div>
                    <div className="item-container__info-container">
                      <HelpIcon
                        styles="margin-left-5 keep-size"
                        onClick={() =>
                          retryCallingHelpTextRef.current.toggleHelpText()
                        }
                        toggled={showRetryCallingHelpText}
                      />
                    </div>
                  </div>
                  <InlineHelpText
                    ref={retryCallingHelpTextRef}
                    toggleFunction={toggleRetryCallingHelpText}
                    message={retryCallingHelpText}
                  />
                </Condition>
              </div>
              <Condition when="retry_after_noans" is={true}>
                <React.Fragment>
                  <div className="content-display__column content-display__column--1-2">
                    <div className="content-display__item-container">
                      <div className="item-container__main-container">
                        <label className="text-large text-light text-deep-blue">
                          <FormattedMessage
                            id="addEditAlertPhoneNumber.numberTimesToCallText"
                            defaultMessage="Number of times to call"
                            description="Set the display mode for this user"
                          />
                        </label>
                        <Field
                          name="retry_cnt"
                          component="input"
                          type="number"
                          className="margin-right-10"
                          min="1"
                        />
                      </div>
                      <div className="item-container__info-container">
                        <HelpIcon
                          styles="margin-left-5 keep-size"
                          onClick={() =>
                            timesToCallHelpTextRef.current.toggleHelpText()
                          }
                          toggled={showTimesToCallHelpText}
                        />
                      </div>
                    </div>
                    <InlineHelpText
                      ref={timesToCallHelpTextRef}
                      toggleFunction={toggleTimesToCallHelpText}
                      message={timesToCallHelpText}
                    />
                  </div>

                  <div className="content-display__column content-display__column--1-2">
                    <div className="content-display__item-container">
                      <div className="item-container__main-container">
                        <label className="text-large text-light text-deep-blue">
                          <FormattedMessage
                            id="addEditAlertPhoneNumber.minutesBetweenCallsText"
                            defaultMessage="How many minutes to wait between calls"
                            description="Set the display mode for this user"
                          />
                        </label>
                        <Field
                          name="retry_interval"
                          component="input"
                          type="number"
                          className="margin-right-10"
                          min="0"
                        />
                      </div>
                      <div className="item-container__info-container">
                        <HelpIcon
                          styles="margin-left-5 keep-size"
                          onClick={() =>
                            minutesBetweenCallsHelpTextRef.current.toggleHelpText()
                          }
                          toggled={showMinutesBetweenCallsHelpText}
                        />
                      </div>
                    </div>
                    <InlineHelpText
                      ref={minutesBetweenCallsHelpTextRef}
                      toggleFunction={toggleMinutesBetweenCallsHelpText}
                      message={minutesBetweenCallsHelpText}
                    />
                  </div>
                </React.Fragment>
              </Condition>
              <Condition when="alert_device_type" is={3}>
                <div className="content-display__column content-display__column--1-2">
                  <div className="content-display__item-container">
                    <div className="item-container__main-container">
                      <label className="text-large text-light text-deep-blue">
                        <Field
                          name="notify_on_clear"
                          component="input"
                          type="checkbox"
                          className="margin-right-10"
                        />
                        <FormattedMessage
                          id="addEditAlertPhoneNumber.notifyOnClear"
                          defaultMessage="Send a notification when an alarm is confirmed"
                          description="Set the display mode for this user"
                        />
                      </label>
                    </div>
                    <div className="item-container__info-container">
                      <HelpIcon
                        styles="margin-left-5 keep-size"
                        onClick={() =>
                          notifyOnClearHelpTextRef.current.toggleHelpText()
                        }
                        toggled={showNotifyOnClearHelpText}
                      />
                    </div>
                  </div>
                  <InlineHelpText
                    ref={notifyOnClearHelpTextRef}
                    toggleFunction={toggleNotifyOnClearHelpText}
                    message={notifyOnClearHelpText}
                  />
                </div>
              </Condition>
              <div className="content-display__column content-display__column--1-2">
                <div className="content-display__item-container">
                  <div className="item-container__main-container">
                    <label className="text-large text-light text-deep-blue">
                      <Field
                        name="restrict_to_interface"
                        component="input"
                        type="checkbox"
                        className="margin-right-10"
                      />
                      <FormattedMessage
                        id="addEditAlertPhoneNumber.restrictCallsText"
                        defaultMessage="Restrict calls to a specific interface"
                        description="Set the display mode for this user"
                      />
                    </label>
                  </div>
                  <div className="item-container__info-container">
                    <HelpIcon
                      styles="margin-left-5 keep-size"
                      onClick={() =>
                        restrictCallsHelpTextRef.current.toggleHelpText()
                      }
                      toggled={showRestrictCallsHelpText}
                    />
                  </div>
                </div>
                <InlineHelpText
                  ref={restrictCallsHelpTextRef}
                  toggleFunction={toggleRestrictCallsHelpText}
                  message={restrictCallsHelpText}
                />
              </div>

              <div className="content-display__column content-display__column--1-2">
                <Condition when="restrict_to_interface" is={true}>
                  <div className="content-display__item-container">
                    <div className="item-container__main-container">
                      <label className="text-large text-light text-deep-blue">
                        <FormattedMessage
                          id="addEditAlertPhoneNumber.interfaceToRestrictText"
                          defaultMessage="Interface to restrict calls to"
                          description="Set the display mode for this user"
                        />
                      </label>
                      <Field
                        className="form-item__field text-bold"
                        name="interface_name"
                        component="select">
                        {interfaceOptions()}
                      </Field>
                    </div>
                    <div className="item-container__info-container">
                      <HelpIcon
                        styles="margin-left-5 keep-size"
                        onClick={() =>
                          interfaceToRestrictCallsHelpTextRef.current.toggleHelpText()
                        }
                        toggled={showInterfaceToRestrictCallsHelpText}
                      />
                    </div>
                  </div>
                  <InlineHelpText
                    ref={interfaceToRestrictCallsHelpTextRef}
                    toggleFunction={toggleInterfaceToRestrictCallsHelpText}
                    message={interfaceToRestrictCallsHelpText}
                  />
                </Condition>
              </div>
              <Condition when="alert_device_type" is={3}>
                <div className="content-display__column content-display__column--1-2">
                  <div className="content-display__item-container">
                    <div className="item-container__main-container">
                      <label className="text-large text-light text-deep-blue">
                        {notesText}:
                      </label>
                      <Field
                        className="form-item__field text-bold"
                        name="notes"
                        component="textarea"
                      />
                    </div>
                    <div className="item-container__info-container">
                      <HelpIcon
                        onClick={() =>
                          notesHelpTextRef.current.toggleHelpText()
                        }
                        toggled={showNotesHelpText}
                        styles="margin-left-5"
                      />
                    </div>
                  </div>
                  <InlineHelpText
                    ref={notesHelpTextRef}
                    toggleFunction={toggleNotesHelpText}
                    message={notesHelpText}
                  />
                </div>
              </Condition>

              <Condition when="alert_device_type" is={3}>
                <div className="content-display__column">
                  <div className="form__item-container">
                    <div className="align-center">
                      <label
                        className="text-medium text-bold"
                        htmlFor="usersId">
                        <FormattedMessage
                          id="addEditAlertPhoneNumber.alertCategoriesLabel"
                          defaultMessage="Alert Device Category:"
                          description="Devices that have been selected."
                        />
                      </label>
                      <HelpIcon
                        onClick={() =>
                          categoryHelpTextRef.current.toggleHelpText()
                        }
                        toggled={showCategoryHelpText}
                        styles="margin-left-5"
                      />
                    </div>
                  </div>
                </div>
                <div className="width-100 margin-bottom-10">
                  <InlineHelpText
                    ref={categoryHelpTextRef}
                    toggleFunction={toggleCategoryHelpText}
                    message={categoryHelpText}
                  />
                </div>
                <div className="content-display__column">
                  {selectedAlertDeviceCategoryTable(values)}

                  <div className="table__header padding-10">
                    <label
                      className="text-medium text-bold"
                      htmlFor="groupsFilter">
                      {searchText}:
                    </label>

                    <input
                      type="text"
                      id="categoryFilter"
                      name="categoryFilter"
                      onChange={categorySearchFilter}
                      className="message-table__filter-search-box margin-left-10"
                      value={categoryFilter}
                    />
                  </div>

                  {alertDeviceCategoryTable(values)}
                </div>
              </Condition>
            </div>
            <div className="width-100 margin-bottom-10"></div>
            <div className="form__section-container form__section-container--spread associate-users-units__form-buttons-container">
              <div className="form__items-group-container" />
              <div className="form__items-group-container">
                <Link
                  className="link link-text"
                  to={props.previous}
                  data-test="add-edit-alert-phone-number-form-cancel-link">
                  {cancelText}
                </Link>
                <Button
                  buttonFunction={buttonFunctions.submit}
                  text={submitText}
                  buttonType={buttonTypes.success}
                  buttonSize={buttonSizes.small}
                  buttonTextSize={buttonTextSizes.mediumSmall}
                  additionalStyles="no-margin margin-left-15"
                  disabled={pristine || invalid}
                />
              </div>
            </div>
          </form>
        )}
      />
    </React.Fragment>
  );
}

const mapStateToProps = (state, ownProps) => {
  return {
    alertDeviceCategories: state.devices.alertDeviceCategories,
    interfaces: state.devices.processDetails,
  };
};
export default connect(mapStateToProps)(UnconnectedAddEditAlertPhoneNumber);
